import {SmartComponent} from "smart-component-js";

class DownloadCouponComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.campaignCode = this.element.dataset.campaignCode;
        this.couponCode = this.element.dataset.couponsetCode;
        this.cta = this.element.querySelector('.download-cta');
        this.message = this.element.querySelector('.mission-completed');
        this.checkLimitEndpoint = `/api/1.0/loyalty/campaign/${this.campaignCode}/coupon-set`;
        this.downloadEndpoint = `/api/1.0/loyalty/campaign/${this.campaignCode}/coupon-set/${this.couponCode}/book-next-available`;
        this.init();
    }

    checkUserLimit() {
        youserxp.ajax(this.checkLimitEndpoint, {
            method: 'GET',
            auth: true,
        }).then((data) => {
            const couponSets = Array.isArray(data.body) ? data.body : [];
            const couponSet = couponSets.find((cs) => cs.code === this.couponCode);
            if (!couponSet) return;
            this.userAvailability = couponSet.userAvailability;
            if (typeof this.userAvailability === 'number' && this.userAvailability <= 0) {
                this.cta.classList.add('hidden');
                this.message.classList.remove('hidden');
            }
        }).catch((err) => {
            console.error(err);
        });
    }

    downloadCouponListener() {
        this.cta.addEventListener('click', () => this.redeemCoupon());
    }

    redeemCoupon() {
        this.element.classList.add('loading');
        youserxp.ajax(this.downloadEndpoint, {
            method: 'POST',
            auth: true,
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        }).then((data) => {
            this.data = data.body;
            this.cta.classList.add('hidden');
            this.message.classList.remove('hidden');
            this.element.classList.remove('loading');

        }).catch((err) => {
            this.element.classList.remove('loading');
            console.error(err);
        });
    }


    init() {
        if (!this.cta) return;
        this.checkUserLimit();
        this.downloadCouponListener();
    }
}

export default DownloadCouponComponent;
